import $api from 'http'
import $apiJSON from 'http/apiJSON'


export async function startLogin(inn) {
  return $apiJSON.post('account/login/start/', { inn })
}

export async function login(inn, pin, options = {}) {
  return $apiJSON.post('account/token/', { inn, pin, ...options })
}

export const postLogin = () => $apiJSON.get('/admin-panel/post-login/')

function isValidId(id) {
  return id !== undefined && id !== null && id !== '' && id !== 'null' && id !== 'undefined'
}

export async function getUserInfo(id) {
  if (!isValidId(id)) {
    return Promise.resolve({ data: null })
  }
  return $apiJSON.get(`employees/employee/${id}/`)
}

export async function postUserInfo(id, data) {
  if (!isValidId(id)) {
    return Promise.resolve({ data: null })
  }
  return $apiJSON.post(`employees/employee/${id}/`, data)
}

export async function getPersonInfo(id) {
  if (!isValidId(id)) {
    return Promise.resolve({ data: null })
  }
  return $apiJSON.get(`employees/employeeone/${id}/`)
}
export async function getWidgetInfo(id) {
  return $apiJSON.get(`task-app-count/${id}/`)
}

export async function getUserId(data) {
  return $api.get('/employees/userid/', data)
}

export async function ChangeProfileImage(imeag) {
  return $api.patch(`employees/profimage/`, { imeag })
}

export async function ChangePassword(new_password) {
  return $apiJSON.patch(`employees/change-password/`, { new_password })
}

export async function ChangePin(payload) {
  return $apiJSON.patch(`employees/change-pin/`, payload)
}

export async function SendQuizAnswers(data) {
  return $apiJSON.post(`/answer/`, data)
}

export async function SendDevice(device) {
  return $apiJSON.post(`/activity/`, { device })
}

export async function ChangeProfileNumber(number_phone) {
  return $api.patch(`employees/profimage/`, { number_phone })
}
export async function ChangeProfileEmail(email) {
  return $api.patch(`employees/profimage/`, { email })
}

export async function checkPinCode(pinCode, userId) {
  return $api.post(`employees/checkpin/`, { pin: pinCode, user_id: userId });
}
